import React from 'react';
import _ from 'lodash';
import StyledPopper from 'components/StyledPopper';
import WorkBreakdownWidget from './WorkBreakdownTrendWidget';
const WorkBreakdownTrendPopper = ({ anchorEl, data = {}, onClose }) => {
  const hasXData = Object.keys(_.get(data, 'x', {})).length > 0;
  const hasYData = Object.keys(_.get(data, 'y', {})).length > 0;

  return !hasXData || !hasYData ? null : (
    <StyledPopper
      id={'transitions-popper'}
      anchorEl={anchorEl}
      onClose={onClose}
      transition
      style={{ zIndex: 1000 }}
      title='WORK BREAKDOWN TREND'
    >
      <WorkBreakdownWidget data={data} />
    </StyledPopper>
  );
};

export default WorkBreakdownTrendPopper;
